/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Error/view.blocks to change it.
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Error({
  children,
  viewPath = "/App/Account/Content/Financial/Content/Statements/Old/Data/Error"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Error.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="large"
 text="There was a problem processing your request, likely because it has too much data."
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="large"
 text="Try narrowing down your filters and contact support if the problem persists."
/>
</div>
{children}
</React.Fragment>)
}